export default {
  name: 'computer',
  translationKey: 'computer-module',
  routePrefix: 'computer',
  routeNamePrefix: 'computer',
  directRoutesAvailable: true,
}
